import React from 'react'

import { applyStyle, formatResponsiveProps } from '../helpers/styles'

export const useScrollStyle = initialProps => {
  const { scroll, scrollX, scrollY, noScroll } = formatResponsiveProps(initialProps)

  return React.useMemo(
    () => `
      ${applyStyle('overflow-y', scroll || scrollY, 'auto')}
      ${applyStyle('overflow-x', scrollX, 'auto')}
      ${applyStyle('overflow', noScroll, 'hidden')}
    `,
    [scroll, scrollX, scrollY]
  )
}
